export const emptyRestriction = {
    name: '',
    startDate: null,
    endDate: null,
    planDisabled: false,
    minLos: 1,
    multiplyMinLos: false,
    allowedCheckinDaysOfWeek: [1, 2, 3, 4, 5, 6, 7],
    allowedCheckoutDaysOfWeek: [1, 2, 3, 4, 5, 6, 7],
    selectedRooms: [],
};

export const isPlanDisabled = (restriction) => getPlanDisabledInfo(restriction).disabled;

export const getPlanDisabledInfo = (restriction) => {
    if (restriction.planDisabled === true) {
        return {
            disabled: true,
            reason: 'The "Disable plan" option is enabled.',
        };
    }
    if (!restriction.allowedCheckinDaysOfWeek?.length) {
        return {
            disabled: true,
            reason: 'No check-in days are selected.',
        };
    }
    if (!restriction.allowedCheckoutDaysOfWeek?.length) {
        return {
            disabled: true,
            reason: 'No check-out days are selected.',
        };
    }
    return { disabled: false, reason: null };
};

/**
 * Payload sent when the disable-plan toggle is on: identity, dates, the flag and the rooms it applies to.
 * The booking rules (min stay, allowed days) are not sent because they are meaningless for a disabled plan.
 */
export const toRestrictionPayload = (restriction) => {
    if (!restriction.planDisabled) {
        return restriction;
    }
    const payload = {
        name: restriction.name,
        startDate: restriction.startDate,
        endDate: restriction.endDate,
        planDisabled: true,
        selectedRooms: restriction.selectedRooms,
    };
    if (restriction.id) {
        payload.id = restriction.id;
    }
    return payload;
};
